import { AgsExportHistory } from 'Components/Ags/Core/AgsExportHistory';
import AgsExportConfiguration from 'Components/Ags/Project/Core/AgsExportConfiguration/AgsExportConfiguration';
import FixedAgsProjectHeader from 'Components/Ags/Project/Core/FixedHeader/FixedAgsProjectHeader';
import ProjectAgsExportSection from 'Components/Ags/Project/Core/ProjectAgsExportSection';
import { ProjectHeader } from 'Components/Ags/Project/Core/ProjectHeader';
import { Message, Spinner } from 'Components/Core';
import ErrorBoundary from 'Components/Core/ErrorBoundary';
import { PageSection } from 'Components/Layout';
import Page from 'Components/Pages/Core/Page';
import { actions } from 'Data/ReduxViewModels/Ags/Project';
import { actions as appActions } from 'Data/ReduxViewModels/App';
import { TitleSource } from 'Data/ReduxViewModels/App/types';
import { hasNonEmptyValue } from 'Lib/Any';
import deepEquals from 'Lib/Object/deepEquals';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import './ProjectPage.scss';

const ProjectPage: React.FC = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const projectId = params.projectId?.toLowerCase();
  const ready = useSelector((state) => state.agsProjectExport.status.ready);
  const errorMessage = useSelector((state) => state.agsProjectExport.status?.errorMessage);
  const tableData = useSelector((state) => state.agsProjectExport.exportHistory, deepEquals);
  const projectCode = useSelector((state) => state.agsProjectExport.projectDetails.projectCode);
  const agsPermission = useSelector((state) => state.user.data?.Claims && state.user.data?.Claims['sq.ags.export']);

  useEffect(() => {
    dispatch(actions.init(projectId!));
  }, [dispatch, projectId]);

  const pageTitle = ready ? [projectCode, 'AGS Data'].filter(hasNonEmptyValue).join(' - ') : undefined;
  useEffect(() => {
    if (hasNonEmptyValue(pageTitle)) dispatch(appActions.setPageTitle({ pageTitle, source: TitleSource.Specific }));
    return () => {
      dispatch(appActions.setPageTitle({ pageTitle: undefined, source: TitleSource.Specific }));
    };
  }, [dispatch, pageTitle]);

  if (!ready) {
    return (
      <Page>
        <Spinner large />
      </Page>
    );
  } else if (errorMessage) {
    return (
      <Page>
        <PageSection>
          <Message error>{errorMessage}</Message>
        </PageSection>
      </Page>
    );
  }

  return (
    <Page>
      <div className="ProjectPage">
        <ErrorBoundary>
          <FixedAgsProjectHeader />
          <div className="ProjectPage-Content">
            <ProjectHeader />
            <AgsExportConfiguration />
            {agsPermission && <ProjectAgsExportSection />}
            <AgsExportHistory
              colWidths={['13%', '13%', '5%', '18%', '13%', '30%', '8%']}
              minColWidths={['90px', '90px', '40px', '135px', '80px', '10px', '40px']}
              name="Project-ExportHistory"
              data={tableData}
              withDateRange={true}
            />
          </div>
        </ErrorBoundary>
      </div>
    </Page>
  );
};

export default ProjectPage;
